<template>
  <div>
    <!-- class="app-container" -->
    <div class="pay">
      <h3>充值管理</h3>
      <el-form
        :inline="true"
        class="demo-form-inline"
        v-loading="loading"
        size="mini"
      >
        <el-form-item label="用户id">
          <el-input
            v-model.number="filter.userId"
            placeholder="用户id"
          ></el-input>
        </el-form-item>
        <el-form-item label="充值户名">
          <el-input
            v-model="filter.accountName"
            placeholder="充值户名"
          ></el-input>
        </el-form-item>
        <el-form-item label="账单状态">
          <el-select v-model="filter.status" placeholder="请选择账单状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="待确认" value="1"></el-option>
            <el-option label="已确认" value="2"></el-option>
            <el-option label="已驳回" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账单流水号">
          <el-input
            v-model="filter.transactionId"
            placeholder="请填写账单流水号"
          ></el-input>
        </el-form-item>
        <el-form-item label="商户订单号">
          <el-input v-model.trim="filter.depositId" placeholder="如 dep-2026…" clearable></el-input>
        </el-form-item>
        <el-form-item label="支付单号">
          <el-input v-model.trim="filter.transId" placeholder="微信/支付宝支付单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="充值方式">
          <el-select v-model="filter.payChannel" placeholder="请选择充值方式">
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="(label, value) in map.finance.rechargeType"
              :key="value"
              :label="label"
              :value="Number(value)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充值类型">
          <el-select v-model="filter.type" placeholder="请选择充值类型">
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="(label, value) in map.finance.rechargeTarget"
              :key="value"
              :label="label"
              :value="Number(value)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充值时间">
          <el-col :span="11">
            <el-date-picker
              v-model="filter.topupStartDate"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="开始时间"
              :picker-options="topupOptionsStart"
              style="margin-right: 10px"
            >
            </el-date-picker>
          </el-col>
          <el-col class="tcenter" :span="2">至</el-col>
          <el-col :span="11">
            <el-date-picker
              v-model="filter.topupEndDate"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="结束时间"
              :picker-options="topupOptionsEnd"
              style="margin-left: 10px"
            >
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="到账时间">
          <el-col :span="11">
            <el-date-picker
              v-model="filter.arrivalStartDate"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="开始时间"
              :picker-options="topuparrivalStartDate"
              style="margin-right: 10px"
            >
            </el-date-picker>
          </el-col>
          <el-col class="tcenter" :span="2">至</el-col>
          <el-col :span="11">
            <el-date-picker
              v-model="filter.arrivalEndDate"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="结束时间"
              :picker-options="topuparrivalEndDate"
            >
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetch(1)" size="mini"
            >查询</el-button
          >
          <el-button type="primary" size="mini" @click="exportExcel"
            >导出</el-button
          >
          <!-- <el-button type="primary" size="mini" @click="exportPayDetailExcel"
          >充值明细导出</el-button
        > -->
        </el-form-item>
      </el-form>
      <div class="table_content">
        <el-table :data="list" style="width: 100%" size="mini">
          <el-table-column
            prop="userId"
            width="110"
            label="用户ID"
          ></el-table-column>

          <el-table-column prop="id" label="账单ID"></el-table-column>
          <el-table-column
            prop="transactionId"
            width="200"
            label="账单流水号"
          ></el-table-column>
          <el-table-column
              prop="depositId"
              width="190"
              label="商户订单号"
              show-overflow-tooltip
          ></el-table-column>
          <el-table-column
              prop="transId"
              width="230"
              label="支付单号"
              show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="accountName"
            label="账户名称"
            width="180"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="phoneNumber"
            width="120"
            label="手机号"
          ></el-table-column>
          <el-table-column
            prop="cardNo"
            width="180"
            label="银行账号"
          ></el-table-column>
          <el-table-column
            prop="bank"
            width="150"
            show-overflow-tooltip
            label="开户银行"
          ></el-table-column>
          <el-table-column
            prop="amount"
            width="140"
            label="充值金额/元(含税)"
          ></el-table-column>
          <el-table-column prop="vat" width="140"  label="增值税金额/元">
           
          </el-table-column>
          <el-table-column prop="prePayPending" label="账单类型">
            <template slot-scope="scope">{{
              map.finance.transactionType[scope.row.transactionType]
            }}</template>
          </el-table-column>
          <el-table-column prop="payChannel" label="充值方式">
            <template slot-scope="scope">{{
              map.finance.rechargeType[scope.row.payChannel]
            }}</template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="充值时间"
            sortable
            width="160"
          ></el-table-column>
          <el-table-column
            prop="arrivalTime"
            label="到账时间"
            sortable
            width="160"
          ></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">{{
              map.finance.topupStatus[scope.row.topupStatus]
            }}</template>
          </el-table-column>
          <el-table-column label="充值凭证" width="80">
            <template slot-scope="scope"
              ><a
                v-if="scope.row.topupProve"
                target="_blank"
                :href="scope.row.topupProve"
                >查看</a
              ></template
            >
          </el-table-column>
          <el-table-column label="到账凭证" width="80">
            <template slot-scope="scope"
              ><a
                v-if="scope.row.arrivalProve"
                target="_blank"
                :href="scope.row.arrivalProve"
                >查看</a
              ></template
            >
          </el-table-column>
          <el-table-column
            prop="rejectRemark"
            width="120"
            show-overflow-tooltip
            label="备注"
          ></el-table-column>
          <el-table-column prop="type" width="120" label="充值类型">
            <template slot-scope="scope">{{
              map.finance.rechargeTarget[scope.row.type]
            }}</template>
          </el-table-column>
          <el-table-column label="操作" width="220">
            <template slot-scope="scope">
              <el-button-group v-if="scope.row.payChannel === 1" size="mini">
                <el-button
                  size="mini"
                  type="primary"
                  :disabled="
                    scope.row.arrivalProve !== '' || scope.row.topupStatus !== 1
                  "
                  @click="toggleDialog('update', scope.row)"
                  >补充信息</el-button
                >
                <el-button
                  size="mini"
                  type="primary"
                  :disabled="scope.row.topupStatus !== 1"
                  @click="updateStatus(scope.row, 2)"
                  >确认</el-button
                >
                <el-button
                  size="mini"
                  type="primary"
                  :disabled="scope.row.topupStatus !== 1"
                  @click="toggleDialog('reject', scope.row)"
                  >驳回</el-button
                >
              </el-button-group>
            </template>
          </el-table-column>
          <div slot="append">
            <div class="footer_bottom">
              <div class="footer_left">当页合计金额</div>
              <div>
                <div class="footer_bottom2">
                  {{ currentPageTotalAmount ? currentPageTotalAmount : 0 }}
                </div>
              </div>
            </div>
            <div class="footer_bottom">
              <div class="footer_left">汇总合计金额</div>
              <div>
                <div class="footer_bottom2">
                  {{ totalAmount ? totalAmount : totalAmount }}
                </div>
              </div>
            </div>
          </div>
        </el-table>
      </div>

      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="pageNum"
          @current-change="(i) => (pageNum = i)"
          :page-size="limit"
          :total="total"
        >
        </el-pagination>
      </div>
      <el-dialog title="请填写驳回理由" :visible.sync="dialog.reject">
        <el-input
          type="textarea"
          placeholder="请填写驳回理由"
          :rows="5"
          v-model.trim="rejectRemark"
          maxlength="100"
        />
        <div slot="footer" class="dialog-footer">
          <el-button @click="toggleDialog('reject')">取 消</el-button>
          <el-button type="primary" @click="updateStatus(curData, 3)"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <el-dialog title="上传到账凭证" :visible.sync="dialog.update">
        <el-form :model="updateForm" :rules="rules" ref="updateForm">
          <el-form-item> 账户名称：{{ curData.accountName }} </el-form-item>
          <el-form-item prop="accountName">
            <el-input
              v-model="updateForm.accountName"
              placeholder="请填写充值的银行户名"
              maxlength="150"
            ></el-input>
          </el-form-item>
          <el-form-item prop="cardNo">
            <el-input
              v-model="updateForm.cardNo"
              placeholder="请填写充值的银行账号"
              maxlength="150"
            ></el-input>
          </el-form-item>
          <el-form-item label="充值金额" prop="inputAmount">
            <el-input
              v-model="updateForm.inputAmount"
              placeholder="请填写客户充值金额"
              maxlength="20"
            ></el-input>
          </el-form-item>

          <el-form-item prop="arrivalTime">
            <el-date-picker
              v-model="updateForm.arrivalTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择到账时间"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="arrivalProve">
            <el-upload
              class="avatar-uploader"
              action="https://up-z1.qbox.me/"
              :show-file-list="false"
              :on-success="handleSuccess"
              :before-upload="beforeUpload"
              :data="uploadData"
              accept="image/png, image/jpeg"
            >
              <img
                v-if="updateForm.arrivalProve"
                :src="updateForm.arrivalProve"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"
                >上传到账凭证
              </i>
              <div slot="tip" class="el-tip">
                只能上传jpg/png文件，且不超过5M
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="toggleDialog('update')">取 消</el-button>
          <el-button type="primary" @click="submitUpdate(updateForm, 'update')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import api from "../api";
import map from "../../datamap";
const { pay, upload, totalAmount } = api;

import moment from "moment";

export default {
  name: "pay",
  data() {
    let checkAccountName = (rule, value, callback) => {
      if (value != this.curData.accountName) {
        return callback(new Error("银行户名与认证账户不一致"));
      } else {
        callback();
      }
    };
    let checkInputAmount = (rule, value, callback) => {
      if (value === null || value === "") {
        return callback(new Error("请输入充值金额"));
      }
      if (Number(value) !== Number(this.curData.amount)) {
        return callback(new Error("输入金额与实际充值金额不一致"));
      }
      callback();
    };
    return {
      map,
      loading: true,
      list: [],

      total: 0,
      pageNum: 1,
      limit: 20,
      totalAmount: "", // 全局充值金额合计
      currentPageTotalAmount: "", // 当页合计金额

      filter: {
        transactionId: "",
        depositId: "",
        transId: "",
        status: "",
        topupStartDate: "",
        topupEndDate: "",
        arrivalStartDate: "",
        arrivalEndDate: "",
        accountName: "",
        payChannel: "",
        userId: this.$route.query.userId,
        type: "",
        pageNum: 1,
        limit: 20,
      },
      rejectRemark: "",
      dialog: {
        reject: false,
        update: false,
      },
      curData: {},
      updateForm: {
        arrivalProve: "",
        cardNo: "",
        bank: "",
        accountName: "",
        inputAmount: null, // 新增输入金额
      },
      uploadData: {
        token: "",
        name: "",
        chunk: 0,
        chunks: 1,
      },
      rules: {
        accountName: [
          {
            required: true,
            message: "请输入银行户名",
          },
          {
            validator: checkAccountName,
          },
        ],
        inputAmount: [
          { 
            required: true, 
            message: "请输入充值金额" 
          },
          { 
            validator: checkInputAmount
          },
        ],
        cardNo: [
          {
            required: true,
            message: "请输入充值账号",
          },
        ],
        arrivalTime: [
          {
            required: true,
            message: "请输入到账时间",
            trigger: "change",
          },
        ],
        arrivalProve: [
          {
            required: true,
            message: "请上传到账凭证",
          },
        ],
      },
      topupOptionsStart: {
        disabledDate: (time) => {
          let endDateVal = this.filter.topupEndDate;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        },
      },
      topupOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.filter.topupStartDate;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          }
        },
      },
      topuparrivalStartDate: {
        disabledDate: (time) => {
          let endDateVal = this.filter.arrivalEndDate;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        },
      },
      topuparrivalEndDate: {
        disabledDate: (time) => {
          let beginDateVal = this.filter.arrivalStartDate;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          }
        },
      },
    };
  },
  watch: {
    pageNum() {
      this.fetch();
    },
    "curData.id"() {
      this.$refs["updateForm"] && this.$refs["updateForm"].resetFields();
    },
  },
  create() {
    // this.filter.userId = this.$route.query.userId;

    this.getTotalAmount();
  },
  methods: {
    getTotalAmount() {
      let {
        transactionId,
        status,
        topupStartDate,
        topupEndDate,
        arrivalStartDate,
        arrivalEndDate,
        accountName,
        payChannel,
        userId,
        type,
        depositId,
        transId,
      } = this.filter;
      let obj = {
        transactionId,
        status,
        topupStartDate,
        topupEndDate,
        arrivalStartDate,
        arrivalEndDate,
        accountName,
        payChannel,
        type,
        depositId,
        transId,
        // userId: Number.isInteger(userId) ? userId : "",
        userId: this.$route.query.userId ? this.$route.query.userId : userId,
      };
      pay.totalAmount(obj).then((res) => {
        this.totalAmount = res.data.data.totalAmount;
      });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "当页合计金额";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          let sumIndex = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          switch (index) {
            case 7:
              sums[index] = sumIndex;
              sums[index] += "";
              break;
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }
      this.loading = true;
      let {
        transactionId,
        status,
        topupStartDate,
        topupEndDate,
        arrivalStartDate,
        arrivalEndDate,
        accountName,
        payChannel,
        userId,
        type,
        depositId,
        transId,
      } = this.filter;
      let obj = {
        transactionId,
        status,
        topupStartDate,
        topupEndDate,
        arrivalStartDate,
        arrivalEndDate,
        accountName,
        payChannel,
        type,
        depositId,
        transId,
        // userId: Number.isInteger(userId) ? userId : "",
        userId: this.$route.query.userId ? this.$route.query.userId : userId,
        pageNum: this.pageNum,
        limit: this.limit,
      };
      let res = await pay.list(obj);
      this.list = res.data.data;
      this.currentPageTotalAmount = res.data.currentPageTotalAmount;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
      this.getTotalAmount();
    },
    async getToken() {
      let res = await upload.token();
      if (res.data.code == 200) {
        this.uploadData.token = res.data.data.up_token;
      }
    },
    submitUpdate(item, name) {
      this.$refs["updateForm"].validate((valid) => {
        if (valid) {
          this.updateInfo(item, name);
        } else {
          return false;
        }
      });
    },
    async updateInfo(item, name) {
      let obj = {
        depositId: this.curData.depositId,
        cardNo: item.cardNo,
        arrivalTime: item.arrivalTime,
        arrivalProve: item.arrivalProve,
      };
      let res = await pay.updateInfo(obj);
      let { code } = res.data;
      if (code === 200) {
        this.$message.success("更新数据成功");
        this.toggleDialog(name);
        this.fetch();
      }
    },
    async updateStatus(data, status) {
      if (status == 2 && data.cardNo == "") {
        this.$message.error("请将信息补充完整！");
        return false;
      }
      let obj = {
        depositId: data.depositId,
        status: status,
        rejectRemark: this.rejectRemark,
      };
      let res = await pay.updateStatus(obj);
      let { code } = res.data;
      if (code === 200) {
        this.$message.success("更新数据成功");
        this.rejectRemark = "";
        if (status == 3) this.toggleDialog("reject");
        this.fetch();
      }
    },
    toggleDialog(name, data) {
      if (name == "reject") {
        this.rejectRemark = "";
      }
      this.dialog[name] = !this.dialog[name];
      if (data) {
        this.curData = data;
      } else {
        this.curData = {};
      }
    },
    // 时间开始选择器
    startTimeStatus: function (name, value) {
      this.filter.name = value;
    },
    // 时间结束选择器
    endTimeStatus: function (name, value) {
      this.filter.name = value;
    },
    handleSuccess(res, file) {
      this.updateForm.arrivalProve = `https:\/\/image.duiyou360.com/${res.key}`;
    },
    beforeUpload(file) {
      const sizeM = file.size / 1024 / 1024;
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt5M = sizeM < 5;
      if (!isJPG || !isLt5M) {
        this.$message.error("只能上传jpg/png文件，且不超过5M!");
      } else {
        this.uploadData.name = file.name;
      }
      return isJPG && isLt5M;
    },
    async exportExcel() {
      this.loading = true;
      let {
        transactionId, status, topupStartDate, topupEndDate,
        arrivalStartDate, arrivalEndDate, payChannel, type,
        accountName, userId, depositId, transId,
      } = this.filter;
      let obj = {
        transactionId, status, topupStartDate, topupEndDate,
        arrivalStartDate, arrivalEndDate, payChannel, type,
        accountName, depositId, transId,
        userId: this.$route.query.userId ? this.$route.query.userId : userId,
        pageNum: this.pageNum,
        limit: this.limit,
      };
      let resp = await pay.export(obj);
      let objectUrl = URL.createObjectURL(new Blob([resp.data]));
      let link = document.createElement("a");
      console.log(link);
      link.download = decodeURIComponent("充值列表.xlsx");
      link.href = objectUrl;
      link.click();
      this.loading = false;
    },
    async exportPayDetailExcel() {
      this.loading = true;
      let { arrivalStartDate, arrivalEndDate } = this.filter;
      let obj = {
        arrivalStartDate,
        arrivalEndDate,
      };
      let resp = await pay.exportPayDetail(obj);
      let objectUrl = URL.createObjectURL(new Blob([resp.data]));
      let link = document.createElement("a");
      console.log(link);
      link.download = decodeURIComponent("充值明细.xlsx");
      link.href = objectUrl;
      link.click();
      this.loading = false;
    },
  },
  mounted() {
    this.fetch();
    this.getToken();
    this.getTotalAmount();
  },
};
</script>
<style >
.avatar-uploader .avatar-uploader-icon {
  font-size: 20px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar-uploader .el-upload {
  width: 100%;
  border: 1px dashed #9ca6ae;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar {
  max-width: 100%;
  max-height: 300px;
  vertical-align: middle;
}
</style>
<style scoped>
.pay {
  height: calc(100vh - 0px) !important;
}

.table_content {
  height: calc(100%) !important;
  /* overflow-y: auto; */
}
.pagination {
  margin: 30px 0 10px;
  float: right;
}
.footer_bottom {
  height: 30px;
  display: flex;
  align-items: center;
}
.footer_bottom2 {
  height: 30px;
  display: flex;
  align-items: center;
  margin-left: 900px;
}
.footer_left {
  width: 120px;
}
</style>


// WEBPACK FOOTER //
// src/views/finance/pay.vue